import React, { ChangeEvent, KeyboardEvent } from 'react';
import { IconButton } from '../common/Button';
import { TextArea } from '../common/Input';
import { SendIcon } from '../common/Icon';
import { cx } from '../../styles';

interface ChatInputProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  loading: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ value, onChange, onSend, loading }) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!loading && value.trim()) {
        onSend();
      }
    }
  };

  return (
    <div className="relative">
      <TextArea
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder="Ask about zkML research and products..."
        rows={1}
        className={cx(
          "min-h-[60px] max-h-[200px] pr-12",
          "bg-component", "text-primary", "placeholder-gray-400",
          "border-main", "focus:border-accent", "focus:ring-accent"
        )}
        disabled={loading}
      />
      
      <div className="absolute right-3 bottom-3">
        <IconButton
          variant={loading || !value.trim() ? 'tertiary' : 'primary'}
          size="medium"
          title="Send message"
          onClick={onSend}
          disabled={loading || !value.trim()}
          className={cx(
            loading || !value.trim() 
              ? "bg-hover text-disabled cursor-not-allowed" 
              : "bg-accent-main text-primary-inverse hover:bg-accent-main/90"
          )}
        >
          <SendIcon size="md" />
        </IconButton>
      </div>
    </div>
  );
};

export default ChatInput;
